// Must be imported before any React.lazy calls to patch Object.freeze
// and prevent the "_status" freeze bug in React 18 production builds.
import './utils/lazyWithRetry'

import * as React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider as ReduxProvider } from 'react-redux'
import { store } from 'app/store'
import { AmplifyApp } from 'app/app'
import { setupLogger } from 'app/logging/setup'

// Initialize logger before app starts
setupLogger()

const root = createRoot(document.getElementById('root') as HTMLElement)

root.render(
    <React.StrictMode>
        <ReduxProvider store={store}>
            <AmplifyApp />
        </ReduxProvider>
    </React.StrictMode>
)
